import styled from "styled-components";

export const ThemedH3 = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #313e48;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
`;

export const ThemedH5 = styled.h5<{ $border?: boolean }>`
  font-family: ${(props) => props.theme.font || "Source Sans Pro"};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  width: fit-content;
  margin: 0px;
  height: 33px;
  border-bottom: solid 4px ${(props) => (props.$border ? props.theme.primary_color : "#00000000")};
`;
